<template>
    <div class="image-input">
        <div v-if="previewUrl" class="preview" :class="{ 'preview--new': !!value.file }">
            <v-img :src="previewUrl" max-height="260" contain class="preview-image" />
            <div class="preview-meta">
                <v-chip v-if="value.file" small color="success" outlined>New image · saved on submit</v-chip>
                <v-spacer />
                <v-btn v-if="!readonly" small text color="error" @click="remove">
                    <v-icon left small>mdi-close</v-icon>Remove
                </v-btn>
            </div>
        </div>
        <div v-else-if="readonly" class="empty">No image</div>
        <div v-else-if="value.remove" class="empty">The current image will be removed on submit.</div>

        <v-file-input
            v-if="!readonly"
            :value="value.file"
            :rules="rules"
            accept="image/png,image/jpeg,image/webp,image/gif,image/heic,image/heif"
            :label="previewUrl ? 'Replace image' : 'Upload image'"
            prepend-icon=""
            prepend-inner-icon="mdi-camera-outline"
            outlined
            show-size
            @change="onFile"
        />
        <v-text-field
            v-if="previewUrl"
            :value="value.description"
            :readonly="readonly"
            label="Image description"
            outlined
            hide-details
            @input="update({ description: $event })"
        />
    </div>
</template>

<script>
    export function emptyImage() {
        return { existing: null, file: null, fileUrl: null, remove: false, description: '', originalDescription: '' }
    }

    export default {
        name: 'ImageInput',
        props: {
            value: {
                type: Object,
                default: emptyImage
            },
            readonly: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                rules: [
                    file => !file || file.size <= 10 * 1024 * 1024 || 'The image must be smaller than 10 MB'
                ]
            }
        },
        computed: {
            previewUrl() {
                if (this.value.fileUrl) {
                    return this.value.fileUrl
                }
                return this.value.existing && !this.value.remove ? this.value.existing.url : null
            }
        },
        methods: {
            update(changes) {
                this.$emit('input', { ...this.value, ...changes })
            },
            onFile(file) {
                if (this.value.fileUrl) {
                    URL.revokeObjectURL(this.value.fileUrl)
                }
                this.update(file ? { file, fileUrl: URL.createObjectURL(file), remove: false } : { file: null, fileUrl: null })
            },
            remove() {
                if (this.value.file) {
                    this.onFile(null)
                } else {
                    this.update({ remove: true })
                }
            }
        }
    }
</script>

<style scoped>
.preview {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 16px;
}

.preview--new {
    border-color: var(--v-success-base);
}

.preview-image {
    border-radius: 4px;
    background: #fafafa;
}

.preview-meta {
    display: flex;
    align-items: center;
    margin-top: 8px;
}

.empty {
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.875rem;
    margin-bottom: 16px;
}
</style>
